import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material";

export class CustomErrorStateMatcher implements ErrorStateMatcher{
    isErrorState(control: FormControl, form: FormGroupDirective | NgForm): boolean {
       
        if(control && control.touched && control.errors && control.errors.required){
            
            return true;
        }
        if(control && control.touched && control.errors && control.errors.pattern){
            return true;
        }
        return false;
    }
    
}